import _isEmpty from 'lodash/isEmpty'
import type { FunctionComponent, ReactNode, Ref } from 'react'
import React from 'react'
import type { DragSortEvent } from '@ztechapps/webui.util'
import { EmptyContent, ErrorContent, LoadingOverlay } from '@ztechapps/webui.util'
import { Stats } from './Stats'
import { ScrollableContent } from './ScrollableContent'
import { TableAndLoadMoreContent } from './TableAndLoadMoreContent'
import type { LoadMoreEntriesFunction } from '@ztechapps/common.hook'
import type { RowConfig, RowProps } from './Row'

export type OnDragSortFunction = (event: DragSortEvent) => void

export type OnRowSelectFunction<T = any> = (args: { _id: string; _config: RowConfig<T> } & T) => void

export type TableProps = {
  scrollable?: boolean
  error?: any
  dataArray: any[]
  loading?: boolean
  emptyContent?: ReactNode
  showEmptyContent?: boolean
  createRow?: any
  row?: FunctionComponent<RowProps>
  selectable?: boolean
  onSelect?: OnRowSelectFunction
  idFieldName?: string
  handleSelect?: any
  currentItem?: any
  head?: ReactNode
  height?: string | number
  foot?: ReactNode
  stats?: ReactNode
  responsive?: string
  className?: string
  tableClassName?: string
  scrollClassName?: string
  showThumb?: boolean
  onDragSort?: OnDragSortFunction
  loadMoreEntries?: LoadMoreEntriesFunction
  filter?: any
  sort?: any
  isEmpty?: boolean
  scrollRef?: Ref<HTMLDivElement>
  'aria-rowcount'?: number
}

export const Table = (props: TableProps) => {
  const { scrollable, error, dataArray, loading } = props
  let showEmptyContent = props?.showEmptyContent ?? true
  let emptyContent = props?.emptyContent

  const content = scrollable ? <ScrollableContent {...props} /> : <TableAndLoadMoreContent {...props} />

  const loadingContent = <LoadingOverlay loading={loading}>{content}</LoadingOverlay>

  //when there is an error, show the errorContent
  if (error) {
    return <ErrorContent error={error} />
  }

  showEmptyContent = showEmptyContent && (_isEmpty(dataArray) || props?.isEmpty) && !loading

  //use the default empty content if there is not specified
  emptyContent = emptyContent ?? <EmptyContent message="No records available." />

  return showEmptyContent ? (
    emptyContent
  ) : (
    <>
      <Stats {...props} />
      {loadingContent}
    </>
  )
}
